import { isValidPhoneNumber } from 'react-phone-number-input';
import * as yup from 'yup';

/** The data of the phone form. The value is already in E.164, because that is what `PhoneInput`
 * returns. */
export type PhoneFormValues = {
  phone: string;
};

/** i18n keys that the resolver writes in `errors.phone.message` and the component translates. */
export const PHONE_VALIDATION_KEYS = {
  required: 'validation.phone.required',
  invalid: 'validation.phone.invalid',
} as const;

/**
 * Validation schema of the phone step. It validates with the same library the input uses, so the two
 * cannot disagree, and it checks the format and not the ownership: the number is not the user's
 * until the link sent to it is opened.
 */
export const createPhoneFormSchema = () =>
  yup.object({
    phone: yup
      .string()
      .required(PHONE_VALIDATION_KEYS.required)
      .test('phone-format', PHONE_VALIDATION_KEYS.invalid, (value) => Boolean(value && isValidPhoneNumber(value))),
  });
